import _styled from "@emotion/styled/base";
import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import { IssueIcon as IssueIcon_default } from "./auth-service-tools24.js";
import { Text as Text$1 } from "./auth-service-tools34.js";
import { useMessages } from "./auth-service-tools33.js";
import { spacing } from "./auth-service-tools25.js";
import { useTDSContext } from "./auth-service-tools97.js";
import { Text } from "./auth-service-tools98.js";
import { colors } from "./auth-service-tools26.js";

const FormField = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e15mrw0"
} : {
  target: "e15mrw0",
  label: "FormField"
})({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: spacing.X4
}, (_ref) => {
  let {
    noMargin
  } = _ref;
  return {
    paddingBottom: noMargin ? 0 : spacing.X24
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

const FormFieldLabel = (_ref2) => {
  let {
    children,
    optional,
    ...props
  } = _ref2;
  const {
    useTDS
  } = useTDSContext();
  const messages = useMessages({
    optional: "sharedComponents.formField.optional"
  });
  return useTDS ? /* @__PURE__ */jsxs(Text, {
    css: {
      marginBottom: `${spacing.X8} !important`
    },
    typography: "bodyEmphasized",
    children: [children, optional && /* @__PURE__ */jsx(Text, {
      css: {
        display: "inline",
        marginLeft: spacing.X4,
        color: colors.GRAYSCALE.X50
      },
      typography: "accentRegular",
      children: messages.optional
    })]
  }) : /* @__PURE__ */jsxs(Text$1, { ...props,
    as: "label",
    weight: "semibold",
    size: "medium",
    children: [children, optional && /* @__PURE__ */jsx(Text$1, {
      css: {
        display: "inline",
        marginLeft: spacing.X4,
        color: colors.GRAYSCALE.X50
      },
      children: messages.optional
    })]
  });
};

const FormFieldDescription = (_ref3) => {
  let {
    children,
    ...props
  } = _ref3;
  const {
    useTDS
  } = useTDSContext();
  return useTDS ? /* @__PURE__ */jsx(Text, { ...props,
    typography: "accentRegular",
    children
  }) : /* @__PURE__ */jsx(Text$1, { ...props,
    size: "small",
    children
  });
};

const FormFieldFeedback = (_ref4) => {
  let {
    children,
    icon: Icon,
    iconColor,
    containerStyles = {},
    error,
    ...props
  } = _ref4;
  const {
    useTDS
  } = useTDSContext();
  return /* @__PURE__ */jsxs("div", {
    css: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.X4,
      ...containerStyles
    },
    children: [/* @__PURE__ */jsx(Icon, {
      size: 13,
      color: iconColor || "systemGrayscale70"
    }), useTDS ? /* @__PURE__ */jsx(Text, {
      typography: "accentRegular",
      color: error ? "systemDetrimentalRegular" : "systemGrayscale80",
      children
    }) : /* @__PURE__ */jsx(Text$1, { ...props,
      as: "label",
      size: "small",
      css: {
        color: colors.GRAYSCALE.X70
      },
      children
    })]
  });
};

const FormFieldError = (_ref5) => {
  let {
    icon: Icon = IssueIcon_default,
    ...props
  } = _ref5;
  return /* @__PURE__ */jsx(FormFieldFeedback, { ...props,
    error: true,
    icon: Icon,
    iconColor: "systemDetrimentalRegular"
  });
};

export { FormField, FormFieldDescription, FormFieldError, FormFieldFeedback, FormFieldLabel };